<template>
  <Vue2OrgTree
    ref="elementRef"
    v-if="this.props.visible"
    :data="model[modelKey]"
    :props="this.props.props"
    :horizontal="this.props.horizontal"
    :labelWidth="this.props.labelWidth"
    :collapsable="this.props.collapsable"
    :renderContent="this.props.renderContent"
    :labelClassName="labelClassName"
    @on-expand="expandHandle"
    @on-node-click="nodeClickHandle"
  >
  </Vue2OrgTree>
</template>

<script>
import CommonUtil from "../../util/CommonUtil";
import ModelUtil from "../../util/ModelUtil";
import ExpressionUtil from "../../util/ExpressionUtil";

export default {
  name: "OrgTreeComponent",
  props: ["elementIndex", "props", "displayData", "detailIndex", "detailModel"],
  data: function() {
    return {
      treeStatus: {}
    };
  },
  beforeMount: function() {
    // 可见
    if (this.props.visible == null) this.$set(this.props, "visible", true);
    // configure props
    if (this.props.itemKey == null) this.$set(this.props, "itemKey", "id");
    var labelKey = "label";
    if (this.props.labelKey) labelKey = this.props.labelKey;
    var expand = "expand";
    if (this.props.expand) expand = this.props.expand;
    this.$set(this.props, "props", {"label": labelKey, "children": '_children_', "expand": expand});
    // node label width
    if (this.props.labelWidth == null) this.$set(this.props, "labelWidth", "auto");
    // children node is collapsable
    if (this.props.collapsable == null) this.$set(this.props, "collapsable", true);
    // how to render node label
    if (this.props.renderContent == null) this.$set(this.props, "renderContent", null);
    // node label class
    if (this.props.horizontal == null) this.$set(this.props, "horizontal", false);
    // node label class
    if (this.props.labelClassName == null) this.$set(this.props, "labelClassName", "bg-white");
    // The className of the selected node
    if (this.props.selectedClassName == null) this.$set(this.props, "selectedClassName", "bg-orange");
    // The key of the selected node
    this.$set(this.props, "selectedObject", null);
  },
  mounted: function() {
    var me = this;
    this.$refs.elementRef.saveExpand = function(){
      me.saveExpand(me.model[me.modelKey]);
    };
    this.$refs.elementRef.loadExpand = function(){
      me.loadExpand(me.model[me.modelKey]);
    };

    // 保存控件实例
    CommonUtil.saveElementToStore(this);
  },
  computed: {
    model: function() {
      if (this.detailModel) {
        return this.detailModel;
      }
      return ModelUtil.getModelObject(this, this.displayData);
    },
    modelKey: function() {
      if (this.detailModel) {
        return this.displayData;
      }
      return ModelUtil.getModelKey(this, this.displayData, "");
    },
  },
  methods: {
    labelClassName: function(data) {
      if (data == this.props.selectedObject) {
        return this.props.selectedClassName;
      } else {
        return this.props.labelClassName;
      }
    },
    expandHandle: function(e, data) {
      if ('expand' in data) {
        data.expand = !data.expand

        if (!data.expand && data.children) {
          this.collapse(data.children)
        }
      } else {
        this.$set(data, 'expand', true)
      }
      if (this.props.onExpand) {
        ExpressionUtil.eval(this, this.props.onExpand, data);
      }
    },
    nodeClickHandle: function(e, data) {
      if (this.props.onNodeClick) {
        ExpressionUtil.eval(this, this.props.onNodeClick, data);
      }
    },
    collapse: function(list) {
      var _this = this
      list.forEach(function(child) {
        if (child.expand) {
          child.expand = false
        }

        child.children && _this.collapse(child.children)
      })
    },
    saveExpand: function(srcObj) {
      this.treeStatus[srcObj[this.props.itemKey]] = srcObj[this.props.props.expand];

      if (srcObj[this.props.props.children]) {
        for (let i=0;i<srcObj[this.props.props.children].length;i++) {
          this.saveExpand(srcObj[this.props.props.children][i]);
        }
      }
    },
    loadExpand: function(srcObj) {
      srcObj[this.props.props.expand] = this.treeStatus[srcObj[this.props.itemKey]];

      if (srcObj[this.props.props.children]) {
        for (let i=0;i<srcObj[this.props.props.children].length;i++) {
          this.loadExpand(srcObj[this.props.props.children][i]);
        }
      }
    },
  }
};
</script>

<style scoped>
/deep/ .bg-white {
  background-color: white;
  cursor: pointer;
}
/deep/ .bg-orange {
  background-color: orange;
  cursor: default;
}
</style>
<style lang="less">
.org-tree-container {
  display: inline-block;
  padding: 15px;
  background-color: #fff;
}

.org-tree {
  // display: inline-block;
  display: table;
  text-align: center;

  &:before, &:after {
    content: '';
    display: table;
  }

  &:after {
    clear: both;
  }
}

.org-tree-node,
.org-tree-node-children {
  position: relative;
  margin: 0;
  padding: 0;
  list-style-type: none;

  &:before, &:after {
    transition: all .35s;
  }
}
.org-tree-node-label {
  position: relative;
  display: inline-block;

  .org-tree-node-label-inner {
    padding: 10px 15px;
    text-align: center;
    border-radius: 3px;
    box-shadow: 0 1px 5px rgba(0, 0, 0, .15);
  }
}
.org-tree-node-btn {
  position: absolute;
  top: 100%;
  left: 50%;
  width: 20px;
  height: 20px;
  z-index: 10;
  margin-left: -11px;
  margin-top: 9px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  box-shadow: 0 0 2px rgba(0, 0, 0, .15);
  cursor: pointer;
  transition: all .35s ease;

  &:hover {
    background-color: #e7e8e9;
    transform: scale(1.15);
  }

  &:before, &:after {
    content: '';
    position: absolute;
  }

  &:before {
    top: 50%;
    left: 4px;
    right: 4px;
    height: 0;
    border-top: 1px solid #ccc;
  }

  &:after {
    top: 4px;
    left: 50%;
    bottom: 4px;
    width: 0;
    border-left: 1px solid #ccc;
  }

  &.expanded:after {
    border: none;
  }
}
.org-tree-node {
  padding-top: 20px;
  display: table-cell;
  vertical-align: top;

  &.is-leaf, &.collapsed {
    padding-left: 10px;
    padding-right: 10px;
  }

  &:before, &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 19px;
  }

  &:after {
    left: 50%;
    border-left: 1px solid #ddd;
  }

  &:not(:first-child):before,
  &:not(:last-child):after {
    border-top: 1px solid #ddd;
  }

}
.collapsable .org-tree-node.collapsed {
  padding-bottom: 30px;

  .org-tree-node-label:after {
    content: '';
    position: absolute;
    top: 100%;
    left: 0;
    width: 50%;
    height: 20px;
    border-right: 1px solid #ddd;
  }
}
.org-tree > .org-tree-node {
  padding-top: 0;

  &:after {
    border-left: 0;
  }
}
.org-tree-node-children {
  padding-top: 20px;
  display: table;
  width: 100%;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    width: 0;
    height: 20px;
    border-left: 1px solid #ddd;
  }

  &:after {
    content: '';
    display: table;
    clear: both;
  }
}

.horizontal {
  .org-tree-node {
    // display: flex;
    // flex-direction: row;
    // justify-content: flex-start;
    // align-items: center;
    display: table-cell;
    float: none;
    padding-top: 0;
    padding-left: 20px;

    &.is-leaf, &.collapsed {
      padding-top: 10px;
      padding-bottom: 10px;
    }

    &:before, &:after {
      width: 19px;
      height: 50%;
    }

    &:after {
      top: 50%;
      left: 0;
      border-left: 0;
    }

    &:only-child:before {
      top: 1px;
      border-bottom: 1px solid #ddd;
    }

    &:not(:first-child):before,
    &:not(:last-child):after {
      border-top: 0;
      border-left: 1px solid #ddd;
    }

    &:not(:only-child):after {
      border-top: 1px solid #ddd;
    }

    .org-tree-node-inner {
      display: table;
    }

  }

  .org-tree-node-label {
    display: table-cell;
    vertical-align: middle;
  }

  &.collapsable .org-tree-node.collapsed {
    padding-right: 30px;

    .org-tree-node-label:after {
      top: 0;
      left: 100%;
      width: 20px;
      height: 50%;
      border-right: 0;
      border-bottom: 1px solid #ddd;
    }
  }

  .org-tree-node-btn {
    top: 50%;
    left: 100%;
    margin-top: -11px;
    margin-left: 9px;
  }

  & > .org-tree-node:only-child:before {
    border-bottom: 0;
  }

  .org-tree-node-children {
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: flex-start;
    display: table-cell;
    padding-top: 0;
    padding-left: 20px;
    width: auto;

    &:before {
      top: 50%;
      left: 0;
      width: 20px;
      height: 0;
      border-left: 0;
      border-top: 1px solid #ddd;
    }

    &:after {
      display: none;
    }

    & > .org-tree-node {
      display: block;
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/spec/OrgTreeComponent.vue